import { Checkbox } from "@/components/ui/checkbox";
import { PODRUCJA, RAZREDI, MJESTA, BUKA, GRUPE, SEZONE, TRAJANJA } from "@/lib/constants";

const Group = ({ title, children }) => (
  <div>
    <p className="text-xs font-bold tracking-[0.08em] uppercase text-slate-400 mb-3">{title}</p>
    <div className="space-y-2">{children}</div>
  </div>
);

const CheckRow = ({ id, label, checked, onChange, testId }) => (
  <label htmlFor={id} className="flex items-center gap-2.5 cursor-pointer group">
    <Checkbox id={id} data-testid={testId} checked={checked} onCheckedChange={onChange}
      className="data-[state=checked]:bg-indigo-600 data-[state=checked]:border-indigo-600" />
    <span className="text-sm text-slate-700 group-hover:text-slate-900 transition-colors duration-150">{label}</span>
  </label>
);

export default function FilterSidebar({ filters, setFilters, onReset }) {
  const toggle = (key, value) =>
    setFilters((f) => ({
      ...f,
      [key]: f[key].includes(value) ? f[key].filter((v) => v !== value) : [...f[key], value],
    }));

  const activeCount =
    filters.razredi.length + filters.podrucja.length + filters.trajanja.length +
    filters.mjesta.length + filters.buka.length +
    (filters.grupa ? 1 : 0) + (filters.sezona ? 1 : 0) + (filters.bezMaterijala ? 1 : 0);

  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-6 space-y-7 lg:sticky lg:top-24" data-testid="filter-sidebar">
      <div className="flex items-center justify-between">
        <p className="font-display font-bold text-slate-900">Filteri</p>
        {activeCount > 0 && (
          <button data-testid="reset-filters-btn" onClick={onReset}
            className="text-xs font-semibold text-indigo-600 hover:text-indigo-800 transition-colors duration-150">
            Očisti ({activeCount})
          </button>
        )}
      </div>

      <Group title="Razred">
        <div className="flex gap-2">
          {RAZREDI.map((r) => (
            <button
              key={r}
              data-testid={`filter-razred-${r}`}
              onClick={() => toggle("razredi", r)}
              className={`h-9 w-9 rounded-full text-sm font-bold transition-colors duration-150 ${
                filters.razredi.includes(r)
                  ? "bg-indigo-600 text-white"
                  : "bg-slate-100 text-slate-600 hover:bg-slate-200"
              }`}
            >
              {r}.
            </button>
          ))}
        </div>
      </Group>

      <Group title="Područje">
        {PODRUCJA.map((p) => (
          <CheckRow key={p.value} id={`pod-${p.value}`} testId={`filter-podrucje-${p.value}`}
            label={p.value} checked={filters.podrucja.includes(p.value)}
            onChange={() => toggle("podrucja", p.value)} />
        ))}
      </Group>

      <Group title="Trajanje">
        {TRAJANJA.map((t) => (
          <CheckRow key={t.id} id={`tr-${t.id}`} testId={`filter-trajanje-${t.id}`}
            label={t.label} checked={filters.trajanja.includes(t.id)}
            onChange={() => toggle("trajanja", t.id)} />
        ))}
      </Group>

      <Group title="Mjesto održavanja">
        {MJESTA.map((m) => (
          <CheckRow key={m} id={`mj-${m}`} testId={`filter-mjesto-${m}`}
            label={m} checked={filters.mjesta.includes(m)} onChange={() => toggle("mjesta", m)} />
        ))}
      </Group>

      <Group title="Razina buke">
        {BUKA.map((b) => (
          <CheckRow key={b} id={`bk-${b}`} testId={`filter-buka-${b}`}
            label={b} checked={filters.buka.includes(b)} onChange={() => toggle("buka", b)} />
        ))}
      </Group>

      <Group title="Veličina grupe">
        <select
          data-testid="filter-grupa"
          value={filters.grupa}
          onChange={(e) => setFilters((f) => ({ ...f, grupa: e.target.value }))}
          className="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
        >
          <option value="">Sve veličine</option>
          {GRUPE.map((g) => (
            <option key={g.value} value={g.value}>{g.label}</option>
          ))}
        </select>
      </Group>

      <Group title="Godišnje doba / blagdan">
        <select
          data-testid="filter-sezona"
          value={filters.sezona}
          onChange={(e) => setFilters((f) => ({ ...f, sezona: e.target.value }))}
          className="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
        >
          <option value="">Sve</option>
          {SEZONE.map((s) => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>
      </Group>

      <CheckRow id="bez-mat" testId="filter-bez-materijala" label="Bez potrebnih materijala"
        checked={filters.bezMaterijala}
        onChange={() => setFilters((f) => ({ ...f, bezMaterijala: !f.bezMaterijala }))} />
    </div>
  );
}
